module.exports = __webpack_public_path__ + "img/rain.fac4f99f.png";